import { render } from "./viewOrder.vue?vue&type=template&id=43ad8370&scoped=true"
import script from "./viewOrder.vue?vue&type=script&lang=js"
export * from "./viewOrder.vue?vue&type=script&lang=js"

import "./viewOrder.vue?vue&type=style&index=0&id=43ad8370&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-43ad8370"

export default script